import { useTranslation } from 'react-i18next'

import { Alert, AlertTitle } from '@/shared/components/ui/alert'

export const PricingTacticDemandView = () => {
	const { t } = useTranslation()

	return (
		<Alert variant='info'>
			<AlertTitle>
				{t('global.pc.settings.demand_strategy.message', {
					defaultValue:
						'Pricing strategy will be inherited from the Optimization group settings.',
				})}
			</AlertTitle>
		</Alert>
	)
}
